var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 94,
    viewBox: "0 0 305 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57837 43.6355C7.86438 43.0424 12.1135 43.3225 16.2797 44.3358C19.1463 45.036 20.3722 41.0569 17.5056 40.3649C12.4914 39.1456 7.47727 38.9562 2.35249 39.6647C-0.56937 40.0683 0.674944 44.0392 3.57837 43.6355Z",
    fill: "#2E397E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.985 93.2527C23.913 91.0385 25.841 88.8243 27.7782 86.6101C29.7062 84.3959 26.4435 81.1612 24.4969 83.3845C22.5689 85.5987 20.6409 87.8129 18.7036 90.0271C16.7756 92.2413 20.0384 95.476 21.985 93.2527Z",
    fill: "#2E397E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0613 4.38891C17.9046 4.56426 20.4981 5.71282 22.5918 7.66799C24.6338 9.57056 27.6839 6.47559 25.6419 4.56426C22.6779 1.79371 19.0764 0.259382 15.0613 0.00512237C12.2956 -0.170229 12.3042 4.21356 15.0613 4.38891Z",
    fill: "#2E397E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.407 80.1396C282.369 82.6893 286.051 84.0308 289.941 83.5866C292.685 83.2756 292.72 78.8336 289.941 79.1446C287.223 79.4555 284.609 78.8337 282.481 76.9947C280.354 75.1646 277.271 78.2917 279.407 80.1396Z",
    fill: "#2E397E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.059 49.1693C294.023 48.7472 297.798 49.1693 301.573 50.4814C304.315 51.4356 305.492 47.0039 302.769 46.0588C298.661 44.6275 294.383 44.1228 290.059 44.5816C287.21 44.8844 287.183 49.4721 290.059 49.1693Z",
    fill: "#2E397E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283.383 16.9226C286.39 13.8926 289.397 10.8626 292.404 7.83253C294.363 5.85868 291.321 2.79401 289.362 4.76786C286.355 7.79789 283.348 10.8279 280.341 13.858C278.382 15.8318 281.424 18.8965 283.383 16.9226Z",
    fill: "#2E397E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogButton);
export default __webpack_public_path__ + "static/media/blogButton.a08c648e6eb55efd3d33f05ea4e7c55d.svg";
export { ForwardRef as ReactComponent };